import React from 'react';
import { classNames } from './classNames';

export interface ListGroupActionProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  active?: boolean;
}

const ListGroupAction = React.forwardRef<HTMLButtonElement, ListGroupActionProps>(({
  active = false,
  type = 'button',
  className,
  children,
  ...props
}, ref) => (
  <button
    ref={ref}
    type={type}
    className={classNames(
      'list-group-item',
      'list-group-item-action',
      active ? 'active' : undefined,
      className,
    )}
    {...props}
  >
    {children}
  </button>
));

ListGroupAction.displayName = 'ListGroupAction';

export default ListGroupAction;
